import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer>
      <img src="photos\Group 502.png" alt=""  />
    </footer>
  );
};

export default Footer;
